import React from 'react'
import PropTypes from 'prop-types'

function Input({
  className,
  dataType,
  defaultValue,
  isDisabled,
  id,
  testid,
  labelText,
  labelPosition,
  maxLength,
  modifier,
  name,
  onBlurHandle,
  onChangeHandle,
  onKeyDown,
  onClick,
  pattern,
  placeholder,
  value,
  type = 'text',
  required,
  isReadonly,
  style,
  reference,
}) {
  return (
    <div className={`input input--${modifier}`}>
      <label htmlFor={id}>
        {(labelPosition === 'left' || labelPosition === undefined) && labelText && <span>{labelText}</span>}
        <input
          ref={reference}
          data-testid={testid}
          data-type={dataType}
          defaultValue={defaultValue}
          disabled={isDisabled}
          readOnly={isReadonly}
          className={className}
          id={id}
          name={name}
          maxLength={maxLength}
          onKeyDown={onKeyDown ? e => onKeyDown(e) : undefined}
          onClick={onClick ? e => onClick(e) : undefined}
          onChange={onChangeHandle ? e => onChangeHandle(e) : undefined}
          onBlur={onBlurHandle ? e => onBlurHandle(e) : undefined}
          pattern={pattern}
          placeholder={placeholder}
          value={value}
          type={type}
          required={required}
          style={style}
        />

        {labelPosition === 'right' && labelText && <span>{labelText}</span>}
      </label>
    </div>
  )
}
Input.propTypes = {
  className: PropTypes.string,
  dataType: PropTypes.string,
  defaultValue: PropTypes.string,
  isDisabled: PropTypes.bool,
  id: PropTypes.string,
  testid: PropTypes.string,
  labelText: PropTypes.string,
  labelPosition: PropTypes.string,
  maxLength: PropTypes.number,
  modifier: PropTypes.string,
  name: PropTypes.string,
  onBlurHandle: PropTypes.func,
  onChangeHandle: PropTypes.func,
  onKeyDown: PropTypes.func,
  onClick: PropTypes.func,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  required: PropTypes.bool,
  isReadonly: PropTypes.bool,
  style: PropTypes.object,
  reference: PropTypes.object,
}

export default Input
